import React from 'react';
import { Tile } from '@op/opds.opux';
import { Message } from '@messageformat/react';
import styles from './InfoTile.module.scss';

interface InfoTileProps {
  number: string;
  description: string | string[];
}

const InfoTile = ({ number, description }: InfoTileProps): React.ReactElement => {
  const listItems = Array.isArray(description) ? description : [description];
  return (
    <Tile>
      <div className={styles.content}>
        <h4 className={styles.header}>
          <div className={styles.title}>
            <Message id="course8.part4.responsibilitytilearticle" />
          </div>
          <div className={styles.number}>{number}</div>
        </h4>
        <div className={styles.description}>
          <ul className={styles.list}>
            {listItems.map((item) => (
              <li key={item}>
                <Message id={item} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Tile>
  );
};

export default InfoTile;
